const formatter = new Intl.NumberFormat('hr-HR');

export function formatMoney(amount: number | null) {
  if (!amount) {
    return null;
  }

  const [wholePart, decimalPart] = (amount / 100).toFixed(2).split('.');

  return `${formatter.format(Number(wholePart))},${decimalPart}`;
}

export function parseMoney(amount: string | null): number | null {
  if (!amount) {
    return null;
  }

  return Number(amount.replace(/[^0-9]+/g, ''));
}

export default {
  formatMoney,
  parseMoney,
};
